import { ReadMore } from '@scripts/read-more/classes/ReadMore.js';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.info-block').forEach(infoBlock => {
        new ReadMore(infoBlock, 'info-block');
    })
})
